<script>
	import { mapState } from 'vuex';

	export default{
		computed:{
			...mapState(['tiendaSeleccionada']),
		},
		methods:{
			selectLocacion(ubicacion){
				this.$emit('setLocacion',ubicacion);
				window.$('#tipo-locacion').modal('hide');
			}
		}
	}
</script>
<template>
	<div id="tipo-locacion" class="modal fade" role="dialog">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="header-modal">
					<label>Búsqueda: Tipo de Locación</label>
					<div class="modal-header-buttons">
						<button type="button">
							<i class="far fa-window-maximize"></i>	
						</button>
						<button type="button" data-dismiss="modal">
							<i class="fas fa-times"></i>	
						</button>
					</div>
				</div>
				<div class="body-modal">
					<table v-if="tiendaSeleccionada == 'autoservicio'" class="table-first-gray table-row-hover">
						<tr>
							<td></td>
							<td>Tipo Ubicación</td>
							<td>Descripción</td>
						</tr>
						<tr @click="selectLocacion('100001')">
							<td></td>
							<td>100001</td>
							<td>RETAIL</td>
						</tr>
						<tr @click="selectLocacion('100002')">
							<td></td>
							<td>100002</td>
							<td>ADMIN CORPORATIVA</td>
						</tr>
						<tr @click="selectLocacion('100012')">
							<td></td>
							<td>100012</td>
							<td>AUTOSERVICIO - ADMINISTRA...</td>
						</tr>
						<tr @click="selectLocacion('100013')">
							<td></td>
							<td>100013</td>
							<td>AUTOSERVICIO - ALMACÉN/CD</td>
						</tr>
						<tr @click="selectLocacion('100036')">
							<td></td>
							<td>100036</td>
							<td>SERVICIO DE ESTACIONAMIENTO</td>
						</tr>
						<tr @click="selectLocacion('100017')">
							<td></td>
							<td>100017</td>
							<td>CLUB DE PRECIOS</td>
						</tr>
						<tr @click="selectLocacion('100018')">
							<td></td>
							<td>100018</td>
							<td>CLUB DE PRECIOS - ADMINISTRACIÓN</td>
						</tr>
						<tr @click="selectLocacion('100019')">
							<td></td>
							<td>100019</td>
							<td>CLUB DE PRECIOS - ALMACÉN</td>
						</tr>
						<tr @click="selectLocacion('100031')">
							<td></td>
							<td>100031</td>
							<td>SUBURBIA</td>
						</tr>
						<tr @click="selectLocacion('100032')">
							<td></td>
							<td>100032</td>
							<td>AUTOSERVICIO ESPECIALIZADO</td>
						</tr>
					</table>
					<table v-if="tiendaSeleccionada == 'sams'" class="table-first-gray table-row-hover">
						<tr>
							<td></td>
							<td>Tipo Ubicación</td>
							<td>Descripción</td>
						</tr>
						<tr @click="selectLocacion('100017')">
							<td></td>
							<td>100017</td>
							<td>CLUB DE PRECIOS</td>
						</tr>
						<tr @click="selectLocacion('100018')">
							<td></td>
							<td>100018</td>
							<td>CLUB DE PRECIOS - ADMINISTRATIVO</td>
						</tr>
						<tr @click="selectLocacion('100019')">
							<td></td>
							<td>100019</td>
							<td>CLUB DE PRECIOS - ALMACÉN/CD</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>